import httpClient from '@/lib/httpClient'
import { useQuery } from '@tanstack/react-query'

export default function useGetTransactionCategories({
  type,
}: {
  type: 'expenses' | 'income'
}) {
  const fetchData = async () => {
    const response = await httpClient.get(
      `/team/transaction-category/${type}`,
    )
    return response.data.data
  }

  // const key = `${type}-categories`

  return useQuery({
    queryKey: ['transaction-categories', { type }],
    queryFn: fetchData,
    enabled: type !== undefined,
  })
}
